import { useCallback } from 'react';

export const useColumnsWidths = ({ compareMode }) => {
  const columnWidthGetter = useCallback(
    ({ name, type }) => {
      if (name === 'Dimension') {
        return 300;
      }

      let width = 120;
      if (compareMode) {
        width *= 1.12;
      }

      if (type === 'creative_status') {
        width = 200;
      }

      return width;
    },
    [compareMode]
  );

  return {
    columnWidthGetter,
  };
};
